import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomShortcutsService {

  newCompany$: Subject<void> = new Subject<void>();

  constructor() {
  }

}
